import { createContext, useContext, useState } from 'react';

const TourContext = createContext();

export const TourProvider = ({ children }) => {
  const [isTourActive, setIsTourActive] = useState(false);
  const [tourStep, setTourStep] = useState(0);
  const [canNavigate, setCanNavigate] = useState(true);

  const startTour = () => {
    setIsTourActive(true);
    setTourStep(0);
    setCanNavigate(false); // Блокируем навигацию при старте тура
  };

  const stopTour = () => {
    setIsTourActive(false);
    setTourStep(0);
  };

  const finishTour = () => {
    setIsTourActive(false);
    setTourStep(0);
    setCanNavigate(true); // Разблокируем навигацию после завершения
  };

  const nextStep = () => {
    setTourStep((prev) => prev + 1);
  };

  const prevStep = () => {
    setTourStep((prev) => Math.max(0, prev - 1));
  };

  const setStep = (step) => {
    setTourStep(step);
  };

  return (
    <TourContext.Provider
      value={{
        isTourActive,
        tourStep,
        canNavigate,
        startTour,
        stopTour,
        finishTour,
        nextStep,
        prevStep,
        setStep,
      }}
    >
      {children}
    </TourContext.Provider>
  );
};

export const useTour = () => {
  const context = useContext(TourContext);
  if (!context) {
    throw new Error('useTour must be used within a TourProvider');
  }
  return context;
};
